import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { createClient } from 'contentful';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'; // Import the library

const ContentfulArticlePage = () => {
  const { slug } = useParams(); // Get the slug from the route
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const client = createClient({
      space: 'g12j3qznit83',
      accessToken: 'vbq3bte2RRUyj8_Mm1UGzxpAXhTn_dvVyUFFrQbUryM',
    });

    client.getEntries({
      content_type: 'uxiArticle', // Replace with your Contentful content type ID
      'fields.slug': slug, // Filter by slug
    })
      .then((response) => {
        setContent(response.items[0]); // Assuming one entry per slug
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data from Contentful:', error);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return <div>Loading content...</div>;
  }

  if (!content) {
    return <div>No content found for this slug.</div>;
  }

  return (
    <div>
      <h1>{content.fields.heading || 'No Heading'}</h1>
      <div>
        {content.fields.articleBody
          ? documentToReactComponents(content.fields.articleBody) // Render Rich Text
          : 'No Article Body'}
      </div>
    </div>
  );
};

export default ContentfulArticlePage;
